function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 982.67487,
    height: 377.95239,
    viewBox: "0 0 982.67486 377.95239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M982.674 377.954H0V.002h982.675Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333
    },
    transform: "translate(0 -.002)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.739 377.954h77.835v-90.412H852.74Z",
    style: {
      fill: "#26549c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333
    },
    transform: "translate(0 -.002)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.501 358.998 22.56-42.32c21.85 14.794 42.424 24.434 60.336 24.434s34.683-5.57 35.13-24.767c.405-17.399-15.434-25.405-41.323-32.52-25.89-7.115-67.59-26.388-67.59-74.116 0-51.417 48.166-68.452 82.135-68.452 33.97 0 60.297 12.314 76.144 21.446l-19.512 39.924c-17.403-10.631-34.385-15.335-49.379-16.052-16.256-.779-32.077 3.836-34.404 17.28-2.372 13.71 5.082 27.704 47.438 39.496 46.5 12.946 61.94 38.715 61.94 68.249 0 22.276-8.375 51.404-39.142 66.354H629.6c-43.733-18.697-73.142-62.162-73.142-112.8 0-67.71 52.572-122.598 121.668-122.598 40.608 0 72.009 16.792 93.314 44.924l-38.18 34.448c-11.25-15.997-31.548-28.164-54.452-28.164-38.366 0-67.957 31.961-67.957 71.39 0 39.426 29.59 71.387 67.957 71.387 22.904 0 43.202-12.167 54.452-28.164l38.18 34.448c-11.677 15.42-26.394 27.421-43.993 35.13h71.784V147.495h53.506v89.34h77.837v-89.34h52.1V.002H0v377.952h393.057c-15.219-5.934-27.18-13.402-34.555-18.956",
    style: {
      fill: "#26549c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333
    },
    transform: "translate(0 -.002)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchLogo);
export default __webpack_public_path__ + "static/media/SCH_logo.fdd0afdaea805987c8bb537ed92fdd07.svg";
export { ForwardRef as ReactComponent };